import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { RefreshCw } from 'lucide-react';
import AssistenteSubstituicaoInsumos from './AssistenteSubstituicaoInsumos';
import { TypedAplication } from '../../@types';
import permissoes from '../../services/permissoes';

interface PendingAproveActionsProps {
  onRefreshPressed: () => void;
  itens: TypedAplication[];
  isLoading?: boolean;
}

const PendingAproveActions: React.FC<PendingAproveActionsProps> = ({
  onRefreshPressed,
  itens,
  isLoading,
}) => {
  const [assistenteVisible, setAssistenteVisible] = useState(false);
  const { canReplaceProducts } = permissoes.users;

  return (
    <>
      <div className="pending-aprove-actions">
        <Button
          className="pending-aprove-actions-btn pending-aprove-actions-btn-refresh"
          label="Atualizar"
          icon={
            <RefreshCw
              size={14}
              className={isLoading ? 'pending-aprove-actions-btn-spin' : ''}
            />
          }
          disabled={isLoading}
          onClick={onRefreshPressed}
        />
        {canReplaceProducts && (
          <Button
            className="pending-aprove-actions-btn pending-aprove-actions-btn-assistant"
            label="Assistente de substituição de insumos"
            onClick={() => setAssistenteVisible(true)}
          />
        )}
      </div>

      <AssistenteSubstituicaoInsumos
        visible={assistenteVisible}
        onHide={() => setAssistenteVisible(false)}
        itens={itens}
      />
    </>
  );
};

export default React.memo(PendingAproveActions);
